export const SAVE_COLUMNS_ID = 'saveColumns'
export const COLUMNS_MANAGER_ID = 'columnsManager'
export const LOAD_CONFIG_ID = 'loadConfig'
